import {ReactNode} from 'react';
import {commonHelpBook} from '../../../stores/Form/HelpBook';
import {hasErrorXpertConditions, showHelp} from '../../../_shared/Help/actions/helpActions';

type Props = {
    text: {text: string};
    searchString: string;
    helpContent?: ReactNode;
};

export const showHelpbook = async ({text, searchString, helpContent}: Props) => {
    commonHelpBook.setShowHelp(true);
    commonHelpBook.setIsLoadingHelpData(true);

    const xpertData = await showHelp({isNewApi: true, searchString});
    const massageBPM = hasErrorXpertConditions(xpertData, text, helpContent);

    commonHelpBook.setHelpMessage(massageBPM);
    commonHelpBook.setIsLoadingHelpData(false);
};
